import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import classes from './scdotPdfReport.module.css';

interface Props {
  title: string;
  rows: any[];
}

const SingleSection = ({ title, rows }: Props) => {
  return (
    <div className={classes.singleSectionContainer}>
      <div className={classes.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th className={classes.singleLeftColumn}>{title}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row?.name}>
                <td className={classes.singleLeftColumn}>{`${row?.name}:`}</td>
                <td>
                  {row?.value
                    ? attributeDisplayUtility.display(
                        row?.value,
                        row?.dataType,
                        row?.unit,
                        !!row?.changeId,
                        row?.newValue,
                      )
                    : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SingleSection;
